<template>
  <div :style="{ isIOS: '40px' }">
    <side-menu class="side-menu" :class="{ active: showMenu }"> </side-menu>
    <div class="xl:ml-sidebar xl:ml-0">
      <navbar></navbar>
      <cart :key="$store.state.showCart"></cart>
      <notifications></notifications>
      <router-view></router-view>
    </div>
    <portal-target name="modal"></portal-target>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';
import Navbar from './components/navbar/Navbar.vue';
import Sidebar from './components/navbar/Sidebar.vue';
import SideMenu from './components/navbar/SideMenu.vue';
import Cart from './components/cart/Cart.vue';
import { mapState } from 'vuex';
// import 'animate.css';

export default {
  name: 'app',
  computed: mapState({
    showSidebar: (state) => state.showSidebar,
  }),
  components: {
    Navbar,
    Sidebar,
    SideMenu,
    Cart,
  },
  computed: mapState({
    showMenu: (state) => state.showMenu,
  }),
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      tasks: [],
      isIOS: false,
    };
  },
  methods: {
    hideSideBar() {
      this.$store.commit('hideSideBar');
    },
  },
  mounted() {
    if (window.cordova) {
      this.isIOS = window.cordova.platformId == 'iOS' || false;
    }
    // console.log(window.cordova.platformId);
    let token = localStorage.getItem('token');
    if (token) {
      let userPayload = jwtDecode(token);
      this.$store.commit('setUser', userPayload);
    }
  },
};
</script>

<style>
@import './assets/css/variables.css';

/* Enter and leave animations can use different */
/* durations and timing functions.              */

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

.side-menu {
  --sidebar-width: 14rem;
  width: var(--sidebar-width);
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100%;
  overflow-x: auto;
  position: fixed;
  background-color: white;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.05);
  z-index: 100;
  transform: translateX(calc(var(--sidebar-width) * -1));
  transition: all 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.side-menu.active {
  transform: translateX(0);
}
@media screen and (min-width: 1200px) {
  .side-menu {
    transform: translateX(0);
  }
}

@media print {
  .side-menu {
    display: none;
  }
}

.side-bar {
  transform: translateX(calc(var(--sidebar-width) * -1));
  transition: all 0.3s ease-in-out;
}

.side-bar.active {
  transform: translateX(0rem);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2;
  display: none;
}
</style>



// WEBPACK FOOTER //
// App.vue?e3e91a98